module.exports = __webpack_public_path__ + "img/03_Paddy_Productivity_I.4bab57e5.png";